import { Box, Typography } from '@mui/material';

import heroImage from '../../../../../assets/imgs/yearbook/2026/hero.png';
import { GradientCircle } from '../../components/GradientCircle';
import { colors } from '../../constants';

type HeroSectionProps = {
  id: string;
  greetings: string[];
};

export function HeroSection({ id, greetings }: HeroSectionProps) {
  return (
    <Box
      id={id}
      mt={{ xs: 4, md: 10 }}
      width="100%"
      display="flex"
      justifyContent="flex-start"
      flexDirection="column"
      position="relative">
      <GradientCircle
        sx={{
          top: { xs: '-50%', lg: '-100%', xl: '-120%' },
          right: { xs: 0, lg: 0, xl: '-20%' },
          width: { xs: 400, lg: 500 },
          height: { xs: 400, lg: 500 },
        }}
      />
      <Box
        component="img"
        src={heroImage}
        sx={{
          width: { xs: '100%', md: '75%', lg: '65%' },
          height: 'auto',
          display: 'block',
        }}
      />
      {greetings.map((greeting, index) => (
        <Typography
          key={index}
          width={{ xs: '100%', md: '65%' }}
          color={colors.text}
          fontSize={{ xs: 16, md: 20 }}
          mt={2}
          textAlign={{ xs: 'center', md: 'left' }}
          fontWeight={index === 0 ? 700 : 500}>
          {greeting}
        </Typography>
      ))}
    </Box>
  );
}
